import { CreateReview } from '../../../components';

const CreateCycle = () => {
  return (
    <div className="p-[10px]">
      <div className="text-[20px] font-[500]">Create New Review Cycle</div>
      <CreateReview />
    </div>
  );
};

export default CreateCycle;
